/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

export default {
    // Get rankings list / periods
    getRankings: async (params = {}) => {
        const queryParams = new URLSearchParams(params).toString();
        return await exeRequest(`/admin/rankings${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Get ranking stats (with optional city filter)
    getStats: async (params = {}) => {
        const queryParams = new URLSearchParams(params).toString();
        return await exeRequest(`/admin/rankings/stats${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Get cities available in rankings
    getCities: async () => await exeRequest("/admin/rankings/cities", "GET"),

    // Get ranking detail by period
    getRankingByPeriod: async (period, params = {}) => {
        const queryParams = new URLSearchParams(params).toString();
        return await exeRequest(`/admin/rankings/${period}${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Recalculate ranking (mode rapide par défaut, fullScan pour scanner tous les chauffeurs)
    recalculate: async (period = null, fullScan = false) => {
        return await exeRequest("/admin/rankings/recalculate", "POST", { period, fullScan });
    },

    // ---- CLASSEMENT TRIMESTRIEL ----

    // Get quarterly rankings list
    getQuarterlyRankings: async (params = {}) => {
        const queryParams = new URLSearchParams(params).toString();
        return await exeRequest(`/admin/quarterly-rankings${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Get quarterly ranking stats
    getQuarterlyStats: async (params = {}) => {
        const queryParams = new URLSearchParams(params).toString();
        return await exeRequest(`/admin/quarterly-rankings/stats${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Get quarterly ranking detail by period
    getQuarterlyRankingByPeriod: async (period, params = {}) => {
        const queryParams = new URLSearchParams(params).toString();
        return await exeRequest(`/admin/quarterly-rankings/${period}${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    // Recalculate quarterly ranking
    recalculateQuarterly: async (period = null) => {
        return await exeRequest("/admin/quarterly-rankings/recalculate", "POST", { period });
    },
};
